import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { formatDate } from 'devextreme/localization';
import { CurrencyDto } from '@/models/CurrencyDto';
import { ExchangeRateDto } from '@/models/currency/ExchangeRateDto';

export class CurrencyService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/currencies');
  }

  public async getAll(): Promise<CurrencyDto[]> {
    return await this.client.get<CurrencyDto[]>('');
  }

  public async getHistoricalExchangeRate(source: string, currency: string, date: Date): Promise<ExchangeRateDto> {
    let dateParam = formatDate(new Date(date), 'yyyy-MM-dd');
    return await this.client.get<ExchangeRateDto>(`/historical-rate?source=${source}&currency=${currency}&date=${dateParam}`);
  }
}
